module.exports = __webpack_public_path__ + "img/safe-browing.de9a2b4e.svg";